import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogProps, Paragraph } from '@expressable/syntax-ds';

type Props = DialogProps & { onBailout: () => void };

export const DirectSignupNoPCPInfoRequiredDialog = ({ onBailout, ...dialogProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog {...dialogProps}>
      <Dialog.Header>
        <Dialog.Title>{t('directSignup.dialogs.noPCPInfoRequired.title')}</Dialog.Title>
      </Dialog.Header>
      <Dialog.Body>
        <Paragraph>{t('directSignup.dialogs.noPCPInfoRequired.body.1')}</Paragraph>
        <Paragraph>{t('directSignup.dialogs.noPCPInfoRequired.body.2')}</Paragraph>
      </Dialog.Body>

      <Dialog.CTAs>
        <Button onClick={onBailout}>{t('directSignup.dialogs.noPCPInfoRequired.confirm')}</Button>
      </Dialog.CTAs>
    </Dialog>
  );
};
